import React from "react"
import "../styles/cover-image.scss"

export const CoverImage = ({ image }) => {
    return (
    <div className="c-cover-image">
        <img className="c-cover-image__image" src={image.url} alt={image.alt}></img>
    </div>
    )
}